/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// footer menu toggles
import './lib/FooterMenu';

//=========================================================
// Sticky Navs
//=========================================================
import StickyMenu from './lib/StickyMenu';
// location pages
const locationNav = document.querySelector<HTMLElement>('.locationNav');
if (locationNav) {
	new StickyMenu(locationNav);
}
// expert pages
const expertsNav = document.querySelector<HTMLElement>('.pageFooter__expertFixedMobileCTA');
if (expertsNav) {
	new StickyMenu(expertsNav);
}

//=========================================================
// Mega Menu
//=========================================================
import './lib/MegaMenu';

//=========================================================
// Plaudit Query Loop
//=========================================================

// mutation observer for 'featured posts' on Health & Active Blog page
import ClassChangeObserver from './component/PlauditQueryLoop/PlauditQueryLoopFilters';
const featuredPostsObserve = new ClassChangeObserver('form.plauditQueryLoop', '.plauditQueryLoop__featuredPosts');
// Floating labels for accessibility
import './component/PlauditQueryLoop/PlauditQueryLoopFieldFocus';

// Colorbox JS
import './lib/Colorbox';


// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //

// To fix scrollbar widths issue on locations page
import './lib/SetScrollBarWidthProperty';

// Notifications
// import './lib/Notifications';

//=========================================================
// Carousel
//=========================================================
import surgeriesCarousel from '../blocks/SurgeriesSlider';
surgeriesCarousel('.surgeriesSlider__slider');

// Urgent Care Banner
import './component/UrgentCareBanner/UrgentCareBanner';
